@if (variant() === 'flat') {
  <button
    neo-flat-button
    [class]="buttonCssClass()"
    [type]="type()"
    [color]="color()"
    [size]="size()"
    [disabled]="isDisabled()"
    [iconOnly]="iconOnly()"
    [wrap]="wrap()"
    [disableRipple]="disableRipple()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-busy]="ariaBusy()"
    [attr.aria-haspopup]="ariaHasPopup()"
    [attr.aria-expanded]="ariaExpanded()"
    [attr.aut-id]="autId()"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>
}

@if (variant() === 'stroked') {
  <button
    neo-stroked-button
    [class]="buttonCssClass()"
    [type]="type()"
    [color]="color()"
    [size]="size()"
    [disabled]="isDisabled()"
    [iconOnly]="iconOnly()"
    [wrap]="wrap()"
    [disableRipple]="disableRipple()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-busy]="ariaBusy()"
    [attr.aria-haspopup]="ariaHasPopup()"
    [attr.aria-expanded]="ariaExpanded()"
    [attr.aut-id]="autId()"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>
}

@if (variant() === 'basic') {
  <button
    neo-button
    class="cm-button-basic"
    [class]="buttonCssClass()"
    [type]="type()"
    [color]="color()"
    [size]="size()"
    [disabled]="isDisabled()"
    [iconOnly]="iconOnly()"
    [wrap]="wrap()"
    [disableRipple]="disableRipple()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-busy]="ariaBusy()"
    [attr.aria-haspopup]="ariaHasPopup()"
    [attr.aria-expanded]="ariaExpanded()"
    [attr.aut-id]="autId()"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>
}

<ng-template #buttonContent>
  @if (loading()) {
    <span class="button-loading" [neo-loader]="true" size="small" [delayText]="''"></span>
  } @else {
    <ng-content />
  }
</ng-template>
